<template>
    <div class="edit">
        <EditComponent />
    </div>
</template>

<script>
import EditComponent from "@/components/edition/EditComponent.vue";

export default {
    name: "Edit",
    components: {
        EditComponent
    }
};
</script>
